import type React from 'react';
import { ListItem } from './ListItem';

export type ListRenderItem<T> = (
  dataItem: T,
  selected?: string | number,
  onClick?: (data: T) => void,
  index?: number
) => React.ReactNode;

export interface ListProps<T> {
  onItemClick?: (data: T) => void;
  data: T[];
  keyName?: string | string[];
  renderItem: ListRenderItem<T>;
  selected?: string | number;
  actionItem?: React.VFC;
  noSpacing?: boolean;
  reverseOrder?: boolean;
}

export const List = <T extends Record<string, any>>({
  data,
  onItemClick,
  renderItem,
  selected,
  keyName = 'id',
  noSpacing = false,
  reverseOrder = false,
  actionItem: ActionItem,
}: ListProps<T>) => {
  const reversedData = [...data].reverse();
  const newData = reverseOrder ? reversedData : data;
  return (
    <ul className="w-full">
      {ActionItem && <ActionItem />}
      {newData.map((dataItem: T, index) => (
        <ListItem
          noSpacing={noSpacing}
          key={
            typeof keyName === 'string'
              ? dataItem[keyName]
              : keyName.map((kname) => dataItem[kname]).join('.')
          }
          selected={
            selected ===
            dataItem[
              typeof keyName === 'string' ? dataItem[keyName] : keyName[0]
            ]
          }
          onClick={() => onItemClick?.(dataItem)}
        >
          {renderItem(dataItem, selected, onItemClick, index)}
        </ListItem>
      ))}
    </ul>
  );
};
